import {
  ASSESSMENT_MODE_FULL_ONLY,
  ASSESSMENT_MODE_LITE_TO_FULL,
} from "./inviteOptions";
import {
  WORKSPACE_COMPANY_MODEL_FLAT,
  WORKSPACE_COMPANY_MODEL_PORTFOLIO,
  isFlatWorkspace,
  workspaceLiteInviteAvailable,
} from "./inviteConstants";

export const LITE_POLICY_AUTO = "auto";
export const LITE_POLICY_ENABLED = "enabled";
export const LITE_POLICY_DISABLED = "disabled";

export function workspaceProductSettings(workspace) {
  return workspace?.product_settings || workspace || {};
}

export function workspaceLitePolicy(workspace) {
  const ps = workspaceProductSettings(workspace);
  if (ps.lite_policy) return ps.lite_policy;
  if (ps.lite_assessments_enabled === true) return LITE_POLICY_ENABLED;
  if (ps.lite_assessments_enabled === false) return LITE_POLICY_DISABLED;
  return LITE_POLICY_AUTO;
}

/** UI dropdown: legacy “auto” maps to enabled (5X) or disabled (generic). */
export function workspaceLitePolicyForUi(workspace) {
  const policy = workspaceLitePolicy(workspace);
  if (policy === LITE_POLICY_AUTO) {
    return workspace?.email_pack === "5x" ? LITE_POLICY_ENABLED : LITE_POLICY_DISABLED;
  }
  if (policy === LITE_POLICY_ENABLED || policy === LITE_POLICY_DISABLED) {
    return policy;
  }
  return LITE_POLICY_DISABLED;
}

export function workspaceDefaultInviteOptions(workspace) {
  if (!workspaceLiteInviteAvailable(workspace)) {
    return {
      assessment_mode: ASSESSMENT_MODE_FULL_ONLY,
      offer_lite_report: "N",
    };
  }
  return {
    assessment_mode: ASSESSMENT_MODE_LITE_TO_FULL,
    offer_lite_report: "Y",
  };
}

export function buildProductSettingsPayload({
  companyModel,
  litePolicy,
  defaultAssessmentMode,
  defaultOfferLiteReport,
}) {
  return {
    company_model:
      companyModel === WORKSPACE_COMPANY_MODEL_FLAT
        ? WORKSPACE_COMPANY_MODEL_FLAT
        : WORKSPACE_COMPANY_MODEL_PORTFOLIO,
    lite_policy: litePolicy,
    default_assessment_mode: defaultAssessmentMode,
    default_offer_lite_report: defaultOfferLiteReport,
  };
}

export { isFlatWorkspace, workspaceLiteInviteAvailable };

/** Hide LITE-only workflows when product settings disable the LITE path. */
export function filterQuickActionsForWorkspace(actions, workspace) {
  if (!Array.isArray(actions) || !actions.length) return [];
  const liteOk = workspaceLiteInviteAvailable(workspace);
  if (liteOk) return actions;
  return actions.filter((action) => action.id !== "lite");
}
